module.exports = __webpack_public_path__ + "img/yuuka kazami_sc1.5e610674.png";